import About from "./MainContain/About";
import Awards from "./MainContain/Awards";
import Background from "./MainContain/Background";
import CaraselImg from "./MainContain/CaraselImg";
import Media from "./MainContain/MediaCoverage";
import NavElements from "./MainContain/NavElements";
import Tournaments from "./MainContain/Tournaments";
import Contact from "./MainContain/contact";
import Footer from "./MainContain/footer";
import Videos from "./MainContain/Videos";
import PdfCard from "./MainContain/PdfElement";
import Woman from "./MainContain/Woman";
import Support from "./MainContain/SupportUs";
import Loader from './MainContain/Loader'

import { useState, useEffect } from "react";



const MainPage = () => {
    const [screenLoading, setScreenLoading] = useState(true);

    useEffect(() => {
        let timer;

        const hidePreloader = () => {
            timer = setTimeout(() => {
                setScreenLoading(false);
            }, 3000);
        };

        if (document.readyState === 'complete') {
            hidePreloader();
        } else {
            document.addEventListener('DOMContentLoaded', hidePreloader);
        }

        return () => {
            clearTimeout(timer);
            document.removeEventListener('DOMContentLoaded', hidePreloader);
        };
    }, []);

    return (
        <>
            {screenLoading ? (
                <Loader />
            ) : (
                <>
                    <NavElements />
                    <CaraselImg />
                    <About />
                    <Woman />
                    <Tournaments />
                    <Awards />
                    <Media />
                    <Background />
                    <Videos />
                    <PdfCard />
                    <Support />
                    <Contact />
                    <Footer />
                </>
            )}
        </>
    );
};

export default MainPage;